export default {
  viewBase: {
    'latestresults': 'Latest results',
    'heartratetrend': 'Heart rate trend(month)',
    'HealthStatistics': 'Health statistics(month)',
    'nodata': 'No data',
    'poor': 'Poor',
    'attention': 'Attention',
    'good': 'Good',
    'averageheartrate': 'Mean heart rate',
    'heartratehealthy': 'Heart rate health',
    'pressureindex': 'Pressure index',
    'fatigueindex': 'Fatigue index',
    'yes': 'Good',
    'normal': 'Normal',
    'overworked': 'Overworked',
    'relaxed': 'Relaxed',
    'male': 'Male',
    'female': 'Female',
    'unknown': 'Unkown',
    'myfamily': 'My family',
    'Delete': 'Delete',
    'prompt': 'Prompt',
    'promptcurrent': ' Are you sure you want to terminate the current family relationship?',
    'promptaccount': ' Does your family have a Guider account?',
    'promptsystem': ' If your family has signed up for the Guider health application with their mobile number, you can directly bind with the mobile account. No matter where you are, you can always pay attention to and manage your family\'s health.',
    'promptrelationship': ' Choose family relationship ',
    'mobilenumber': 'Mobile number',
    'promptmobile': 'Please enter the mobile number.',
    'relationship': 'Family relationship ',
    'bindnow': 'Bind now',
    'promptrelationshipnot': 'Family relationship not selected ',
    'promptmobilenot': 'Mobile number format error ',
    'bindsuc': 'Bind successfully',
    'save': 'Save',
    'name': 'Name',
    'entername': 'Please Enter A Name',
    'head': 'Profile picture',
    'gender': 'Gender',
    'promptgender': 'Select gender',
    'dateofbirth': 'Date of birth',
    'select': 'Please select',
    'detailedaddress': 'Detailed address',
    'promptaddress': 'Please enter the detailed address',
    'promptnamenot': 'Name blanked',
    'promptgendernot': 'Gender blanked ',
    'promptdate': 'Date of birth blanked ',
    'addedsuc': 'Add successfully',
    'nomore': 'No more',
    'high': 'high',
    'low': 'low',
    'oxygen': 'Blood oxygen(%)',
    'flowvelocity': 'Blood flow velocity',
    'loading': 'Loading...',
    'goodtwo': 'Good',
    'viewECG': 'View ECG',
    'next': 'Next step',
    'ECGpicturenot': 'ECG picture acquisition failed ',
    'averageheartbeat': 'Mean heart rate',
    'promptfat': 'Controlling the three highs (hyperlipidemia, high blood pressure, high blood glucose), maintaining good habits and controlling weight can help maintain healthy blood vessels and reduce excess heart work.',
    'promptpressure': 'When under stress or tension, your heart rate will increase and it may cause irregularities. It is recommended to maintain a peaceful mood and find appropriate ways to relieve pressure to help maintain your health.',
    'promptchronic': 'You can refer to the chronic fatigue index at the same time. If the chronic fatigue index is yellow or red, it means that the pressure is accumulated for a long time, you must pay attention to it.',
    'promptfeel': 'Avoid staying up all night and being overworked and taking appropriate rest. If you are not feeling well for a long time and your rest cannot be improved, it is recommended to go to the hospital for treatment.',
    'height': 'Height（cm）',
    'weight': 'Weight（kg）',
    'promptweight': 'Please enter the weight',
    'promptheight': 'Please enter the height',
    'uploading': 'Uploading...',
    'promptcorrectheight': 'Please fill in the correct height ',
    'promptcorrectweight': 'Please fill in the correct weight ',
    'promptcorrectbirthday': 'Please fill in the correct birthday ',
    'editsuc': 'Edit successfully',
    'promptcall': 'Are you sure you want to make a call?',
    'logout': 'Log out',
    'contactus': 'Contact us',
    'privacypolicy': 'Privacy policy',
    'helpcenter': 'Help',
    'instructions': 'Instructions',
    'basicinformation': 'Basic information',
    'mobilelogin': 'Mobile login',
    'promptmobilelogin': 'Please enter the mobile number',
    'promptcode': 'Please enter code ',
    'login': 'Log in',
    'checkok': 'I have carefully read, understood and agreed',
    'promptuser': '《Terms of User Service Agreement and Privacy Policy》',
    'putcode': 'Send',
    'promptcodenote': 'Verification code format error ',
    'placepassword': ' please enter password',
    'noaccountnumber': ' has no account number',
    'immediateregistration': 'sign up immediately',
    'passwordfromerror': ' password format is incorrect',
    'passwordfromerrorsure': ' enter password inconsistency twice',
    'placepasswordsix': ' please enter at least 6 bits password',
    'surepassword': ' confirm',
    'password': ' password',
    'adressandcounty': ' country and region',
    'phoneadress': ' mobile phone number belongs to',
    'china': ' China',
    'phoneformaterror': 'Telephone number format error',
    'codeformaterror': 'Verification code error',
    'pleasephone': ' Please fill in the tel number.',
    'getwechatnot': 'Failed to get WeChat information ',
    'sendTo': 'Has Been Sent To',
    'codeInfo': 'The Verification Code Is 4 Digits',
    promptuserpla: 'Please agree to the `User Service Agreement and Privacy Policy Terms`'
  }
}
